import styled from 'styled-components'

import { FemiColor } from '../../constants'
import { FemiTitle } from '../../styles'

export const StyledFemiPauseSubscription = {
  Description: styled.p`
    margin-bottom: 24px;
    color: ${FemiColor.DARK};
    font-size: 17px;
    font-weight: 400;
    line-height: 26px;
  `,
  Title: styled(FemiTitle)`
    margin-bottom: 24px;
    font-size: 24px;
    line-height: 32px;
  `,
}
